import React, {useEffect, useState} from 'react';
import {Button} from "@mui/material";
import {ReactComponent as ZoomInIcon} from "../../../../../../assets/promos&items/zoom_in_icon.svg";
import {ReactComponent as ZoomOutIcon} from "../../../../../../assets/promos&items/zoom_out_icon.svg";
import {useTypedSelector} from "../../../../../../hooks/useTypeSelector";
import {useDispatch} from "react-redux";
import {
    toggleFlyerZoomInModeForFramesPromosScreens
} from "../../../../../../store/actionCreators/toggleActionForEditorActionCreators";

const ZoomInOut = () => {
    const dispatch = useDispatch();
    const {toggleActionsForFlyers} = useTypedSelector((state) => state);
    const [isZoomIn, setIsZoomIn] = useState<boolean>(toggleActionsForFlyers.isZoomIn);

    useEffect(() => {
        setIsZoomIn(toggleActionsForFlyers.isZoomIn)
    }, [toggleActionsForFlyers.isZoomIn])
    const onZoom = () => {
        dispatch(toggleFlyerZoomInModeForFramesPromosScreens());
    }

    return (
        <Button
            sx={{
                padding: "4px",
                '&:hover': {
                    backgroundColor: '#107EC61A',
                },
                "&:disabled": {
                    opacity: "0.4"
                }
            }}
            onClick={onZoom}>
            {isZoomIn ? <ZoomOutIcon/> : <ZoomInIcon/>}
        </Button>
    );
}

export default ZoomInOut;